import React from 'react';
import env from 'env';
import { Table } from 'components/table/table';
import { useGet } from 'components';
import utils from 'utils';
import { SiteLink } from 'components';
import { Loading, ErrorPopup } from 'components';

/** ProductType.LiveFeed value — filter list to live feed products only. */
const LIVE_FEED_PRODUCT_TYPE = 4;

export function LiveFeedList(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Stream / Product Name',
        accessor: 'productName',
        Cell: (c) => (
          <SiteLink to={`/admin/product/${c.row.original.productId}`}>
            <b>{c.cell.value}</b>
          </SiteLink>
        )
      },
      {
        Header: 'Status',
        accessor: 'productStatusText'
      },
      {
        Header: 'Url',
        accessor: 'productSlug'
      },
      {
        Header: 'Price',
        accessor: 'price'
      },
      {
        Header: 'Updated Date',
        accessor: 'dateUpdated',
        Cell: (c) => c.cell.value && utils.date.formatYYYYMMDD(c.cell.value)
      }
    ],
    []
  );

  const get = useGet();

  React.useEffect(() => {
    const url = `${env.apiBase}/api/productAdmin/getList?productType=${LIVE_FEED_PRODUCT_TYPE}`;
    get.send(url);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <Loading />;
  }
  if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />;
  }

  const data = get.response || [];
  return (
    <>
      <h1>Live feeds</h1>
      <p className="text-muted">Stream products only. Edit opens the full product form with Live Feed fields.</p>
      <div className="filter" style={{ minHeight: '30px' }}>
        <SiteLink className="btn btn-outline-primary" to="/admin/product/new?type=livefeed">
          Add live stream
        </SiteLink>
      </div>
      <Table columns={columns} data={data} />
    </>
  );
}
